<template>
  <div>
    <div>
      <vue-dropzone
        ref="myVueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        @vdropzone-complete="afterComplete"
      ></vue-dropzone>
    </div>
    <div
      class="main-container bg-grey-lightest"
      v-if="parsed_resume && parsed_resume.resume"
    >
      <div class="main-content-wrap">
        <div class="main-content-pannel flex main-content-pannel-t">
          <div class="flex-2 main-content-left">
            <div
              class="tech-resume-info tech-resume-info-p flex items-center justify-center"
            >
              <div class="flex-1">
                <h3>
                  {{ parsed_resume.resume.name | getShorterName }}
                </h3>
                <p>Location: {{ parsed_resume.resume.address }}</p>
              </div>
              <div class="tech-resume-info-avatar">
                <div class="tech-resume-info-avatar-container">
                  <span>{{ parsed_resume.resume.name | getFirstLetter }}</span>
                </div>
              </div>
            </div>
            <div class="main-pannel">
              <h3 class="main-pannel-header">Certifications</h3>
              <div class="main-pannel-content tech-cert-content">
                <ul
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.certifications
                  "
                >
                  <li
                    v-for="(certification, index) in parsed_resume.resume.resume
                      .certifications"
                    :key="index"
                  >
                    <a
                      href="javascript:void(0)"
                      class="flex items-center"
                      @click="onClickCertification(index)"
                    >
                      <div
                        class="image"
                        :style="{
                          backgroundImage: `url(${certification.image_url}`,
                        }"
                      ></div>
                      <div class="flex-1">{{ certification.description }}</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="main-pannel">
              <h3 class="main-pannel-header">Skills</h3>
              <div class="main-pannel-content tech-cert-content">
                <ul
                  class="tech-skill-content"
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.skills
                  "
                >
                  <li
                    v-for="(skill, index) in parsed_resume.resume.resume.skills"
                    :key="index"
                  >
                    <a href="javascript:void(0)">
                      {{ skill }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="main-pannel">
              <h3 class="main-pannel-header">Tools</h3>
              <div class="main-pannel-content tech-cert-content">
                <ul
                  class="tech-skill-content"
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.tools
                  "
                >
                  <li
                    v-for="(tool, index) in parsed_resume.resume.resume.tools"
                    :key="index"
                  >
                    <a href="javascript:void(0)" @click="onClickTool(index)">{{
                      typeof tool === "string" ? tool : tool.name
                    }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="flex-3 main-content-right">
            <div class="work-history main-pannel">
              <h3 class="main-pannel-header">Work Histories</h3>
              <div class="main-pannel-content">
                <section
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.work_histories
                  "
                >
                  <div
                    class="tech-resume-timeline flex"
                    v-for="(workHistory, index) in parsed_resume.resume.resume
                      .work_histories"
                    :key="index"
                    :style="{
                      background:
                        workHistory.yn_prediction_from_title === 'Y'
                          ? 'lightgreen'
                          : 'lightcoral',
                    }"
                  >
                    <div class="tech-resume-timeline-header flex-column">
                      <div>
                        <h6>
                          {{ workHistory.company_name }}
                        </h6>
                        <div
                          v-if="workHistory.image_url"
                          class="image"
                          :style="{
                            backgroundImage: `url(${workHistory.image_url}`,
                          }"
                        ></div>
                        <div>
                          <i class="material-icons-outlined align-middle"
                            >place</i
                          >
                          {{ workHistory.location }}
                        </div>
                      </div>
                      <div class="ai-predict">
                        <div v-if="workHistory.displayIt">
                          IT:
                          {{
                            workHistory.displayIt === "NULL"
                              ? "Not enough info to judge"
                              : workHistory.displayIt
                          }}
                        </div>
                        <div
                          v-if="
                            workHistory.displayIt === 'Yes' &&
                            workHistory.displayType
                          "
                        >
                          Type:
                          {{ workHistory.displayType }}
                        </div>
                      </div>
                    </div>
                    <div class="flex-1 tech-resume-timeline-content">
                      <div class="tech-resume-timeline-time">
                        {{
                          workHistory.start_time | dateformatFilter("MMM YYYY")
                        }}
                        to
                        {{
                          workHistory.end_time
                            | dateformatFilter("MMM YYYY", true)
                        }}
                      </div>
                      <h6>{{ workHistory.job }}</h6>
                      <p
                        v-for="(experience, idx) in workHistory.experiences"
                        :key="idx"
                      >
                        {{ experience }}
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div class="education main-pannel">
              <h3 class="main-pannel-header">Educations</h3>
              <div class="main-pannel-content">
                <section
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.educations
                  "
                >
                  <div
                    class="tech-resume-timeline flex"
                    v-for="(education, index) in parsed_resume.resume.resume
                      .educations"
                    :key="index"
                  >
                    <div class="tech-resume-timeline-header">
                      <h6>{{ education.school_name }}</h6>
                      <div>
                        <i class="material-icons-outlined align-middle"
                          >place</i
                        >
                        {{ education.location }}
                      </div>
                    </div>
                    <div class="flex-1 tech-resume-timeline-content">
                      <div class="tech-resume-timeline-time">
                        {{
                          education.start_time | dateformatFilter("MMM YYYY")
                        }}
                        to
                        {{
                          education.end_time
                            | dateformatFilter("MMM YYYY", true)
                        }}
                      </div>
                      <h6>{{ education.major }}</h6>
                      <p
                        v-for="(experience, idx) in education.experiences"
                        :key="idx"
                      >
                        {{ experience }}
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div class="main-pannel">
              <h3 class="main-pannel-header">References</h3>
              <div class="main-pannel-content">
                <ul
                  class="blockquote"
                  v-if="
                    parsed_resume.resume.resume &&
                    parsed_resume.resume.resume.references
                  "
                >
                  <li
                    v-for="(reference, index) in parsed_resume.resume.resume
                      .references"
                    :key="index"
                  >
                    <p>
                      {{ reference.content }}
                      <span>{{ reference.signature }}</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { db } from "@/vendor/firebase";
import { storagePut, storageGetDownloadUrl } from "@/vendor/firebase";
import { randomString } from "@/utils/utils";
import { httpGet } from "@/http/http";
import * as utils from "@/utils/utils";

export default {
  name: "app",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: function () {
    return {
      parsed_resume: null,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
      },
    };
  },
  watch: {
    parsed_resume() {
      if (
        this.parsed_resume &&
        this.parsed_resume.resume &&
        this.parsed_resume.resume.resume
      ) {
        if (this.parsed_resume.resume.resume.work_histories) {
          this.parsed_resume.resume.resume.work_histories = utils.sortArray(
            this.parsed_resume.resume.resume.work_histories,
            "start_time"
          );
          this.consultant.resume.work_histories.forEach((item) => {
            if (item.yn_prediction_from_title) {
              item.displayIt =
                item.yn_prediction_from_title === "Y"
                  ? "Yes"
                  : item.yn_prediction_from_title === "N"
                  ? "No"
                  : "NULL";
            } else {
              item.displayIt = "NULL";
            }

            if (item.displayIt === "Yes") {
              if (
                item.tier_prediction_from_title &&
                item.tier_prediction_from_title !== "Not an IT person"
              ) {
                item.displayType = item.tier_prediction_from_title;
              } else if (
                item.tier_prediction_from_desc &&
                item.tier_prediction_from_desc !== "Not an IT person"
              ) {
                item.displayType = item.tier_prediction_from_desc;
              } else {
                item.displayType = "Tier 3 IT person";
              }
            }
          });
        }
        if (this.parsed_resume.resume.resume.educations)
          this.parsed_resume.resume.resume.educations = utils.sortArray(
            this.parsed_resume.resume.resume.educations,
            "start_time"
          );
      }
    },
  },
  // mounted() {
  //   this.bindData("QmMsIVE0LNW4B9tI8sVG");
  // },
  methods: {
    async afterComplete(upload) {
      try {
        const file = upload;
        const array = file.name.split(".");
        const fileType = array.length > 1 ? "." + array[array.length - 1] : "";
        const fileName = "resume_" + randomString(10) + fileType;
        await storagePut(`resume_upload/`, fileName, file);
        const getResult = await storageGetDownloadUrl(
          `resume_upload/${fileName}`
        );
        const fileUrl = getResult.data;
        await httpGet("test_upload_resume", { fileUrl })
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "upload success",
              });
              this.bindData(result.data);
            } else {
              this.$toasted.global.toast_error({ message: "upload error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            // this.submitLoading = false;
          });
      } catch {
        console.log("error");
      }
    },
    bindData(id) {
      this.$bind("parsed_resume", db.collection("test_upload_resumes").doc(id));
    },
  },
};
</script>

<style scoped>
.ai-predict {
  margin: 0 0 2rem 2rem;
  text-align: left;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 0.5rem;
}
.ai-predict > div {
  font-size: 1.5rem;
  font-weight: bold;
}
.flex-column {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>

